/**
 * Wire format for contractor nested in GET /booking/v2/assistance/api/bs/{bsId}/cases/{caseId}.
 * Matches si.medifit.booking2.domain.readmodel.assistance.BusinessCaseResponseDTO.ContractorDTO.
 */
export interface CaseContractorDto {
    id?: number;
    contractorId?: string;
    bpi?: string;
    name?: string;
    contractorAddress?: string;
    contractorOrgUnitAddress?: string;
}

/** App-facing contractor on a business case — same fields as {@link CaseContractorDto}, with `bpi` renamed to `bpiType`. */
export interface CaseContractor {
    id?: number;
    contractorId?: string;
    bpiType?: string;
    name?: string;
    contractorAddress?: string;
    contractorOrgUnitAddress?: string;
}

/** Maps assistance case contractor payload; only renames `bpi` → `bpiType`. */
export function mapCaseContractorDto(dto: CaseContractorDto): CaseContractor {
    const { bpi, ...rest } = dto;
    return {
        ...rest,
        bpiType: bpi,
    };
}
